<!--
 * @Author: gaozexiong RJgaozexiong@ruijie.com.cn
 * @Date: 2022-07-27 15:10:08
 * @LastEditors: gaozexiong RJgaozexiong@ruijie.com.cn
 * @LastEditTime: 2022-09-06 15:27:33
 * @FilePath: \ces-vue-serve\src\views\Chief\order\handleSubject\doItActionBox.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class="rj-page-card">
    <div class="rj-page-card__content">
      <div class="rj-row">
        <el-form ref="form" :model="formData" :rules="rules">
          <el-form-item prop="byType" label="是否接单">
            <el-radio-group v-model="formData.byType">
              <el-radio :label="1">
                确认接单
              </el-radio>
              <el-radio :label="9">
                拒绝接单
              </el-radio>
            </el-radio-group>
          </el-form-item>

          <el-form-item v-if="formData.byType==9" prop="reason">
            <el-input v-model.trim="formData.reason" type="textarea" :rows="4" placeholder="请输拒绝理由" show-word-limit maxlength="200" />
          </el-form-item>
          <el-form-item style="margin-bottom: 4px">
            <el-button type="primary" :loading="loading" @click="submit">
              确认
            </el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>
<script type="es6">
import { mapActions } from 'vuex';
import { IntegratorsConfirmOrRefusOrder } from '../../../../API/index';
import eventBus from '@/libs/eventBus';
export default {
  data () {
    return {
      formData: {
        byType: 1,
        reason: ''
      },
      loading: false,
      rules: {
        reason: [{ required: true, message: '请输拒绝理由', trigger: 'blur' }],
        byType: [{ required: true, message: '请选择是否接单', trigger: 'change' }]
      }
    };
  },
  props: {
    // 数据由父组件传递
    baseInfo: {
      type: Object,
      default: () => { return {}; }
    }
  },
  components: {},
  computed: {},
  methods: {
    ...mapActions([
      'getIsCurrentApprover'
    ]),
    submit () {
      this.$refs.form.validate(async (val) => {
        // 输入验证成功后 调用接口
        if (val) {
          // let isApprover = await this.getIsCurrentApprover(this.baseInfo.documentID);
          // if (!isApprover) {
          let params = {
            documentID: this.baseInfo.documentID,
            orderType: this.baseInfo.orderType,
            newEcpFlag: Number(this.$route.query.newEcpFlag)
          };
          if (this.formData.byType === 9) {
            // params.optionType = 2;
            params.optionType = 4;// 渠道确认接单
            params.reason = this.formData.reason;
          } else {
            // params.optionType = '3';
            params.optionType = 3; // 渠道拒绝接单
          }
          this.loading = true;
          IntegratorsConfirmOrRefusOrder(params).then((res) => {
            let json = res.data;
            this.loading = false;
            if (json.status === '200') {
              eventBus.$emit('CompleteChiefOrder'); // 完成订单操作
              this.$router.replace({
                name: 'ChiefOrderList'
              });
            }
          }).catch(() => {
            this.loading = false;
          });
        }
        // }
      });
    }
  },
  mounted () {

  }
};
</script>
<style lang="scss">
</style>
